"use strict";const n=require("react/jsx-runtime"),r=({content:e,isActive:a,id:i,labelledBy:l})=>n.jsx("div",{role:"tabpanel",id:i,"aria-labelledby":l,hidden:!a,children:e});module.exports=r;
//# sourceMappingURL=_TabPanel.js.map
